import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { EventiDataSource } from 'src/app/services/eventi.datasource';
import { EventiService } from 'src/app/services/eventi.service';
import { RichiesteDgpeService } from 'src/app/services/richieste-dgpe.service';
import { SelezioneDpgrDialogComponent } from '../selezione-dpgr-dialog/selezione-dpgr-dialog.component';

@Component({
  selector: 'app-dettaglio-richiesta',
  templateUrl: './dettaglio-richiesta.component.html',
  styleUrls: ['./dettaglio-richiesta.component.css']
})
export class DettaglioRichiestaComponent implements OnInit, AfterViewInit, OnDestroy {

  public form: FormGroup;
  public isModifica: boolean;
  public isDettaglio: boolean;
  public isNewRichiesta: boolean;
  private idRichiesta: number;
  navigationSubscription: any;
  dataSource: EventiDataSource;
  displayedColumns: string[] = ['dpgr', 'descrizione', 'dataEvento'];
  risultatiPerPagina: number = 10;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('orderBy') orderBy: MatSelect;
  eventiSearchableDto: ModelEventiCalamitosi.EventiSearchableDto = {
    idEvento: null,
    dpgr: null,
    dataEventoDa: null,
    dataEventoA: null,
    primaDataChiusuraRaccolta: null,
    descrizione: null,
    stato: null
  };
  emptyTableMessage: boolean = false;


  constructor(
    private router: Router,
    private richiesteSvc: RichiesteDgpeService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private alertsCenterService: AlertsCenterService,
    private route: ActivatedRoute,
    private eventiSvc: EventiService,
  ) {
    this.idRichiesta = this.route.snapshot.params.idRichiesta ? this.route.snapshot.params.idRichiesta : null;
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
      }
    });
  }




  ngOnInit(): void {
    this.buildForm();
    this.dataSource = new EventiDataSource(this.eventiSvc);
    this.dataSource.errors$.subscribe(res => {
      if (res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })


  }

  ngAfterViewInit(): void {
    setTimeout(() => {

      this.modeSelector();

      if (this.idRichiesta !== null) {
        this.dataSource.loadEventiByRichiesta('', this.idRichiesta, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);
      }

      this.dataSource.counter$.subscribe(res => {

        if (res === 0) this.emptyTableMessage = true
        else this.emptyTableMessage = false;
      })
      this.form.valueChanges.subscribe(() => this.paginator.pageIndex = 0);
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => {
            this.dataSource.loadEventiByRichiesta('', this.idRichiesta, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);
          }))
        .subscribe();

      this.dataSource.counter$
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();
    });
  }

  ngOnDestroy(): void {
  }

  private modeSelector() {

    this.isDettaglio = this.router.url.includes('dettaglio-richiesta') ? true : false;
    this.isModifica = (this.router.url.includes('modifica-richiesta')) ? true : false;
    this.isNewRichiesta = (this.router.url.includes('nuova-richiesta')) ? true : false;

    if (this.isDettaglio || this.isModifica) {
      this.buildFormDetail();
    }

  }

  buildForm() {
    this.form = new FormGroup({
      idRichiesta: new FormControl(null, null),
      ocdpc: new FormControl(null, Validators.required),
      informazioniOcdpc: new FormControl(null, Validators.required),
      territorio: new FormControl(null, Validators.required),
      commissario: new FormControl(null, Validators.required),
      dataInizio: new FormControl(null, Validators.required ),
      dataFine: new FormControl(null, Validators.required),
      budget: new FormControl(null, [Validators.required, Validators.pattern("^[0-9]+,[0-9][0-9]$")])
    });
  }



  onNavigate(path: string) {
    if(path.includes('elenco-interventi')) {
      this.router.navigate([this.router.url + "/elenco-interventi"])
    }else {
      this.router.navigateByUrl(path);
    }
  }

  onSaveEvent() {
    this.validateData(this.form.controls.dataInizio,this.form.controls.dataFine);
    if (!this.form.invalid) {
      let richiesteDgeDTO: ModelEventiCalamitosi.RichiestaDgpeDTO = {
        idRichiesta: this.form.controls.idRichiesta.value ? this.form.controls.idRichiesta.value : null,
        ocdpc: this.form.controls.ocdpc.value,
        informazioniOcdpc: this.form.controls.informazioniOcdpc.value,
        territorio: this.form.controls.territorio.value,
        commissario: this.form.controls.commissario.value,
        dataInizio: this.datePipe.transform(this.form.controls.dataInizio.value, "yyyy-MM-dd"),
        dataFine: this.datePipe.transform(this.form.controls.dataFine.value, "yyyy-MM-dd"),
        budget: this.form.controls.budget.value,
        dataUltimaModifica: null,
        utenteUltimaModifica: null,
        descrizioneEvento: 'prova',
        stato: 'BOZZ',
        numEventi: null,
      }
      this.richiesteSvc.upserRichiesta(richiesteDgeDTO).subscribe(res => {
        if (richiesteDgeDTO.idRichiesta) {
          this.alertsCenterService.showAlert({
            message: 'Modifica avvenuta con successo',
            type: 'success',
            autoClosable: false
          });
          this.buildFormDetail();
        } else {
          this.alertsCenterService.showAlert({
            message: 'Salvataggio avvenuto con successo',
            type: 'success',
            autoClosable: false
          });
          this.router.navigate(['elenco-richieste/modifica-richiesta/' + res.body.idRichiesta])
        }
      },
        err => {
          this.alertsCenterService.showAlert({
            message: err.error.esitoServizio.descrizioneEsito,
            type: 'danger',
            autoClosable: false
          });
        })
    } else this.markAsTouched(this.form)
  }

  openAggiungiDpgrDialog() {
    //inserire qui la configurazione della material dialog MatDialogConfig per dati e css
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '800px';
    dialogConfig.data = {ocdpc: this.form.controls.ocdpc.value, listaDpgrEmpty: this.emptyTableMessage};

    const dialogRef = this.dialog.open(SelezioneDpgrDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.dataSource.loadEventiByRichiesta('', this.idRichiesta, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);

    });
  }

  private markAsTouched(form: FormGroup) {
    for (const key in form.controls) {
      form.get(key).markAsTouched();
    }
  }

  private buildFormDetail() {
    let idRichiesta = this.route.snapshot.params.idRichiesta;
    this.richiesteSvc.getRichiestaById(idRichiesta).subscribe(res => {
      let budget = this.replaceDotWithComma(res.budget)
      this.form = new FormGroup({
        idRichiesta: new FormControl({ value: res.idRichiesta, disabled: this.isDettaglio && !this.isModifica }, null),
        ocdpc: new FormControl({ value: res.ocdpc, disabled: this.isDettaglio && !this.isModifica }, Validators.required),
        informazioniOcdpc: new FormControl({ value: res.informazioniOcdpc, disabled: this.isDettaglio && !this.isModifica }, Validators.required),
        territorio: new FormControl({ value: res.territorio, disabled: this.isDettaglio && !this.isModifica }, Validators.required),
        commissario: new FormControl({ value: res.commissario, disabled: this.isDettaglio && !this.isModifica }, Validators.required),
        dataInizio: new FormControl({ value: res.dataInizio, disabled: this.isDettaglio && !this.isModifica }, Validators.required),
        dataFine: new FormControl({ value: res.dataFine, disabled: this.isDettaglio && !this.isModifica }, Validators.required),
        budget: new FormControl({ value: budget, disabled: this.isDettaglio && !this.isModifica }, [Validators.required, Validators.pattern("^[0-9]+,[0-9][0-9]$")])
      });
    });
  }

  private replaceDotWithComma(value: number) : string {
    let val = value.toFixed(2).toString();
    return val.replace(".",",");
  }

  private validateData (dataInizio: AbstractControl, dataFine: AbstractControl)  {
    if (dataInizio.value > dataFine.value) {
      dataInizio.setErrors({ 'invalidData': true });
    } else dataInizio.setErrors(null);

  }
}
